
(function() {
  function runCustomScripts() {
    console.log('custom scripts');
    setTimeout(() => {
      const notifWrapper = document.querySelector('.notif-wrapper');
      const notifText = document.querySelector('.notification-text');
      if (notifWrapper && notifText) {
        notifWrapper.appendChild(notifText);
      }
    }, 300);
  }

  // Wait until DOM is fully loaded
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runCustomScripts);
  } else {
    runCustomScripts();
  }
})();